// function haversineDistance(coord1, coord2) {
//   const R = 6371; // km
//   const dLat = (coord2.lat - coord1.lat) * Math.PI / 180;
//   const dLng = (coord2.lng - coord1.lng) * Math.PI / 180;
//   const lat1 = coord1.lat * Math.PI / 180;
//   const lat2 = coord2.lat * Math.PI / 180;

//   const a = Math.sin(dLat/2) ** 2 +
//             Math.sin(dLng/2) ** 2 * Math.cos(lat1) * Math.cos(lat2);
//   return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
// }

// function kMeans(points, k, maxIterations = 100) {
//   // Randomly initialize centroids
//   let centroids = points
//     .sort(() => 0.5 - Math.random())
//     .slice(0, k);
//   // console.log("centroids",centroids)
//   let assignments = [];
//   for (let iter = 0; iter < maxIterations; iter++) {
//     console.log("points",points,iter)
//     // Step 1: Assign points to closest centroid
//     assignments = points.map(p => {
//       let minDist = Infinity;
//       let clusterIdx = 0;
//       centroids.forEach((c, i) => {
//         const dist = haversineDistance(p, c);
//         if (dist < minDist) {
//           minDist = dist;
//           clusterIdx = i;
//         }
//       });
//       console.log("clusterIdx",clusterIdx)
//       return clusterIdx;
//     });

//     console.log("assignments",assignments)

//     // Step 2: Update centroids
//     const newCentroids = Array(k).fill(null).map(() => ({ lat: 0, lng: 0, count: 0 }));

//     points.forEach((p, i) => {
//       const cluster = assignments[i];
//       newCentroids[cluster].lat += p.lat;
//       newCentroids[cluster].lng += p.lng;
//       newCentroids[cluster].count += 1;
//     });
//     console.log("newCentroids",newCentroids)
//     newCentroids.forEach((c, i) => {
//       if (c.count > 0) {
//         c.lat /= c.count;
//         c.lng /= c.count;
//       } else {
//         c.lat = centroids[i]?.lat;
//         c.lng = centroids[i]?.lng;
//       }
//     });
//     console.log("newCentroids 2",newCentroids)
//     // Stop if centroids didn't change
//     if (JSON.stringify(newCentroids) === JSON.stringify(centroids)) {
//       break;
//     }
//     centroids = newCentroids;
//   }

//   return { centroids, assignments };
// }

// export default kMeans;

function haversineDistance(coord1, coord2) {
  const R = 6371; // km
  const dLat = (coord2.lat - coord1.lat) * Math.PI / 180;
  const dLng = (coord2.lng - coord1.lng) * Math.PI / 180;
  const lat1 = coord1.lat * Math.PI / 180;
  const lat2 = coord2.lat * Math.PI / 180;

  const a = Math.sin(dLat/2) ** 2 +
            Math.sin(dLng/2) ** 2 * Math.cos(lat1) * Math.cos(lat2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
}
function kMeans(points, k, maxIterations = 100) {
  if (!points || points.length === 0) return { centroids: [], assignments: [] };

  // If k is invalid → fall back to simple points
  if (k <= 1 || points.length <= 1) {
    return { centroids: points.map(p => ({ ...p, count: 1 })), assignments: [0] };
  }

  k = Math.min(k, points.length);

  // Randomly initialize centroids
  let centroids = points
    .slice() // copy
    .sort(() => 0.5 - Math.random())
    .slice(0, k)
    .map(p => ({ ...p, count: 1 }));

  let assignments = [];
  for (let iter = 0; iter < maxIterations; iter++) {
    assignments = points.map(p => {
      let minDist = Infinity;
      let clusterIdx = 0;
      centroids.forEach((c, i) => {
        const dist = haversineDistance(p, c);
        if (dist < minDist) {
          minDist = dist;
          clusterIdx = i;
        }
      });
      return clusterIdx;
    });

    const newCentroids = Array(k).fill(null).map(() => ({ lat: 0, lng: 0, count: 0 }));

    points.forEach((p, i) => {
      const cluster = assignments[i];
      newCentroids[cluster].lat += p.lat;
      newCentroids[cluster].lng += p.lng;
      newCentroids[cluster].count += 1;
    });

    newCentroids.forEach((c, i) => {
      if (c.count > 0) {
        c.lat /= c.count;
        c.lng /= c.count;
      } else {
        c.lat = centroids[i].lat;
        c.lng = centroids[i].lng;
        c.count = 1;
      }
    });

    if (JSON.stringify(newCentroids) === JSON.stringify(centroids)) break;
    centroids = newCentroids;
  }

  return { centroids, assignments };
}

export default kMeans;